import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  WebApiSliceState,
  WebApiBody,
  WebApiHeader,
  WebApiQueryParam,
  WebApi,
} from "./web-api-interface";
import {
  createWebApi,
  fetchWebApiByAppUuid,
  fetchWebApiByUuid,
} from "./web-api-async-calls";

const initialState: WebApiSliceState = {
  webApis: [],
  selectedWebApi: null,
  selectedWebApiBody: undefined,
  selectedWebApiHeaders: undefined,
  selectedWebApiQueryParams: undefined,
  isFetching: false,
};

const webApiSlice = createSlice({
  name: "webApi",
  initialState,
  reducers: {
    setSelectedWebApi: (state, action: PayloadAction<WebApi>) => {
      state.selectedWebApi = action.payload;
    },
    setSelectedWebApiBody: (state, action: PayloadAction<WebApiBody>) => {
      state.selectedWebApiBody = action.payload;
    },
    setSelectedWebApiHeaders: (
      state,
      action: PayloadAction<WebApiHeader[]>
    ) => {
      state.selectedWebApiHeaders = action.payload;
    },
    setSelectedWebApiQueryParams: (
      state,
      action: PayloadAction<WebApiQueryParam[]>
    ) => {
      state.selectedWebApiQueryParams = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWebApiByAppUuid.pending, (state) => {
        state.webApis = [];
        state.isFetching = true;
      })
      .addCase(fetchWebApiByAppUuid.fulfilled, (state, action) => {
        state.webApis = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchWebApiByAppUuid.rejected, (state) => {
        state.webApis = [];
        state.isFetching = false;
      })
      .addCase(fetchWebApiByUuid.pending, (state) => {
        state.selectedWebApi = null;
        state.isFetching = true;
      })
      .addCase(fetchWebApiByUuid.fulfilled, (state, action) => {
        state.selectedWebApi = action.payload;
        state.selectedWebApiBody = action.payload.body;
        state.isFetching = false;
      })
      .addCase(fetchWebApiByUuid.rejected, (state) => {
        state.selectedWebApi = null;
        state.isFetching = false;
      })
      .addCase(createWebApi.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(createWebApi.fulfilled, (state, action) => {
        state.webApis = [...state.webApis, action.payload];
        state.isFetching = false;
      })
      .addCase(createWebApi.rejected, (state) => {
        state.isFetching = false;
      });
  },
});

export const {
  setSelectedWebApi,
  setSelectedWebApiBody,
  setSelectedWebApiHeaders,
  setSelectedWebApiQueryParams,
} = webApiSlice.actions;
export default webApiSlice.reducer;
